import gs from "gstyles";

export default function Icon({
  ...props
}: {
  name: string;
  size?: number;
  className?: string;
  [key: string]: any;
}) {
  return gs.icons({ ...props });
}
